import {
  profile, sections as labels, about, films, photos, experience, education,
  skills, languages, art, music, sports, associative, contact,
} from "@/data/portfolio";

const sec = (id, type, data) => ({ id, type, label: labels[id]?.label, object: labels[id]?.object, visible: true, data });

export const CREDITS = {
  aiNote: "Ce site a été codé avec l'IA.",
  intro: "Merci à celles et ceux qui ont rendu cette chambre possible.",
  people: [{ name: "", role: "Idée originale", description: "", photo: "", links: [] }],
};

// Contenu d'exemple, utilisé tant que rien n'a été enregistré depuis l'éditeur (/admin)
export const DEFAULT_CONTENT = {
  profile,
  sections: [
    sec("about", "about", about),
    sec("films", "films", { items: films }),
    sec("photos", "gallery", { items: photos.map((p) => ({ image: p.src, title: "", caption: p.caption })) }),
    sec("experience", "timeline", { items: experience.map((e) => ({ period: e.period, title: e.title, subtitle: e.company, place: e.place, description: e.description })) }),
    sec("education", "timeline", { items: education.map((e) => ({ period: e.period, title: e.title, subtitle: e.school, place: "", description: e.description })) }),
    sec("skills", "skills", { categories: skills.map((c) => ({ name: c.category, items: c.items })) }),
    sec("languages", "languages", languages),
    sec("art", "gallery", { items: art.map((a) => ({ image: a.image, title: a.title, caption: `${a.medium}, ${a.year}` })) }),
    sec("music", "music", music),
    sec("sports", "cards", { items: sports.map((s) => ({ title: s.name, subtitle: s.since, description: s.detail })) }),
    sec("associative", "timeline", { items: associative.map((a) => ({ period: a.period, title: a.role, subtitle: a.organization, place: "", description: a.description })) }),
    sec("contact", "contact", contact),
    { id: "credits", type: "credits", label: "Crédits", object: "Le projecteur", visible: true, data: CREDITS },
  ],
};

export const BUILT_IN_IDS = DEFAULT_CONTENT.sections.map((s) => s.id);
